export enum CustomTheme {
  Sage = "Sage",
  Volotea = "Volotea",
}
